import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AddMultipleComponent, IAddedItem } from 'components/input/add-multiple/add-multiple.component';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent, CustomRadioButtonDirective } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { DateInputComponent } from 'components/input/date-input/date-input.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { TagsComponent } from 'components/input/tags/tags.component';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { ValidationType } from 'enums/validationType';
import { TagModel } from 'models/generated/Models.TagModel';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { ComponentUrl } from 'services/navigation.service';
import { EditableContent } from 'components/input/editable-content/editable-content.component';

@Component({
	selector: 'debug-input-fields',
	templateUrl: './debug-input-fields.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, DataTableComponent, DataRowComponent, CustomInputComponent, DateInputComponent, CustomSelectComponent, AddMultipleComponent, TagsComponent, ListView, TranslatePipe, CustomRadioButtonDirective, EditableContent]
})
@ComponentUrl('debug-input-fields')
@CredentialRequired(CredentialType.AccessDebugViews)
export class DebugInputFieldsComponent implements OnInit {
	@ViewChild('resetValuesButton') resetValuesButton!: SubmitButtonComponent;
	@ViewChild('pushNewValuesToSelectListsButton') pushNewValuesToSelectListsButton!: SubmitButtonComponent;
	@ViewChild('changeSelectListsButton') changeSelectListsButton!: SubmitButtonComponent;

	@ViewChild('confirmButton') confirmButton!: ButtonComponent;
	@ViewChild('rejectButton') rejectButton!: ButtonComponent;
	@ViewChild('neutralButton') neutralButton!: ButtonComponent;
	@ViewChild('ghostButton') ghostButton!: ButtonComponent;
	@ViewChild('confirmButtonSmall') confirmButtonSmall!: ButtonComponent;
	@ViewChild('rejectButtonSmall') rejectButtonSmall!: ButtonComponent;
	@ViewChild('neutralButtonSmall') neutralButtonSmall!: ButtonComponent;
	@ViewChild('ghostButtonSmall') ghostButtonSmall!: ButtonComponent;

	selectButtons = false;
	disableButtons = false;
	checkValidation = false;
	showButtonIcons = false;
	enlarge = false;
	inputTypeEnum = InputType;
	validationType = ValidationType;
	validationTypeSelectList = Array(8).fill(0).map((_, i) => new SelectListItemModel(`${i}`, this.validationType[i]));
	selectedValidationTypeString = '';
	get selectedValidationType(): ValidationType {
		return parseInt(this.selectedValidationTypeString);
	}

	// Custom Input
	textValueValidation = '';
	textValue? = 'some name';
	emailValue? = '';
	textareaValue? = 'some name';
	numberValue?= 42;
	currencyValue? = 22555.23;
	percentageValue? = 42;
	switchValue? = false;
	radioValue?: boolean | number;
	dateValue?: Date = new Date(2023, 3, 10);
	today = new Date();

	// Add multiple
	addMultipleRequired = false;
	emitNewValues = false;
	listenToItemAdded = false;
	listenToSelectedItemsChange = false;

	selectListShortValue?: SelectListItemModel;
	selectListLongValue?: SelectListItemModel;
	selectListShort = ['Køb domæne (.dk)', 'Onboarding 1', 'Onboarding 2', 'Onboarding 3', 'Fotopakke', 'Produktion af fotopakke med meget lang beskrivelse, med meget lang beskrivelse, med meget lang beskrivelse'].map(x => new SelectListItemModel(`${x} - value`, x));
	selectListLong = [...Array(100).keys()].map(x => new SelectListItemModel(`${x}`, `${x}`));

	selectedTags = ['tag1'].map(t => ({ tag: t } as TagModel));
	tagOptions = ['tag2', 'tag3'].map(t => ({ tag: t } as TagModel));

	itemsOptions0: IAddedItem[] = ['Køb domæne (.dk)', 'Onboarding 1', 'Onboarding 2', 'Onboarding 3', 'Fotopakke'].map(x => ({ value: `${x} - value`, label: x } as IAddedItem));
	itemsOptions1: IAddedItem[] = ['Køb domæne (.dk)', 'Onboarding 1', 'Onboarding 2', 'Onboarding 3', 'Fotopakke'].map(x => ({ value: `${x} - value`, label: x } as IAddedItem));
	itemsSelected0: IAddedItem[] = [];
	itemsSelected1: IAddedItem[] = [];

	numbers = [{ value: -22 }, { value: 100 }, { value: -0 }, { value: 33002 }, { value: 3 }, { value: -3000 }, { value: 23 }, { value: 2000 }, { value: -2000 }, { value: 0 }, { value: -22 }, { value: 45 }];

	ngOnInit(): void {}

	resetCustomInputValues() {
		this.textValueValidation = '';
		this.textValue = undefined;
		this.emailValue = undefined;
		this.numberValue = undefined;
		this.currencyValue = undefined;
		this.percentageValue = undefined;
		this.switchValue = false;
		setTimeout(() => {
			this.resetValuesButton.succeeded();
			this.resetValuesButton.reset();
		}, 500);
	}

	confirmClick() {
		console.log('confirm');
		setTimeout(() => { this.confirmButton.reset(); this.confirmButtonSmall.reset(); }, 2000);
	}
	rejectClick() {
		console.log('reject');
		setTimeout(() => { this.rejectButton.reset(); this.rejectButtonSmall.reset(); }, 2000);
	}
	neutralClick() {
		console.log('neutral');
		setTimeout(() => { this.neutralButton.reset(); this.neutralButtonSmall.reset(); }, 2000);
	}
	ghostClick() {
		console.log('ghost');
		setTimeout(() => { this.ghostButton.reset(); this.ghostButtonSmall.reset(); }, 2000);
	}

	pushNewValuesToSelectLists() {
		this.selectListShort.push(new SelectListItemModel('hejvalue', 'Beskrivelse af hej'));
		this.selectListLong.push(new SelectListItemModel('hejvalue', 'Beskrivelse af hej'));
		this.pushNewValuesToSelectListsButton.succeeded();
		this.pushNewValuesToSelectListsButton.reset();
	}

	changeSelectLists() {
		this.selectListShort = [new SelectListItemModel('hejvalue', 'Beskrivelse af hej')];
		this.selectListLong = [new SelectListItemModel('hejvalue', 'Beskrivelse af hej')];
		this.changeSelectListsButton.succeeded();
		this.changeSelectListsButton.reset();
	}

	reactToEvent(event: any, s: string) {
		console.log(event);
		alert(s);
	}

	showValues(selectList: IAddedItem[]) {
		return selectList.map(item => item.value);
	}
}
